export const themeEditorUiConfigCalendar = [
  {
    sectionName: "Content Blocks - Calendar - Month",
    sectionKey: "contentBlocks.calendar",
    description: "Styling for calendar content block type",
    groups: [
      {
        groupName: "Calendar Common",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.container.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Calendar default text color",
            options: {
              allowInherit: true,
              modalTitle: "Clock Time Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.calendar.container.background",
            component: "ColorSelector",
            default: "#f1f5f9",
            description: "Calendar default background color",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.container.fontSize",
            component: "FontSizeSelector",
            default: "1.5rem",
            allowCustom: true,
            description: "Calendar default font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.container.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Calendar default font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar default font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Calendar - Month",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.month.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Calendar month text color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Month Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.month.fontSize",
            component: "FontSizeSelector",
            default: "1.5rem",
            allowCustom: true,
            description: "Calendar month font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.month.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Calendar month font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.month.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar month font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Calendar - Weekdays",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.weekdays.color",
            component: "ColorSelector",
            default: "#475569",
            description: "Calendar weekdays text color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Weekdays Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.weekdays.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Calendar weekdays font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.weekdays.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Calendar weekdays font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.weekdays.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar weekdays font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Calendar - Week Numbers",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.weeknumbers.color",
            component: "ColorSelector",
            default: "#64748b",
            description: "Calendar week numbers text color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Week Number Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.calendar.weeknumbers.background",
            component: "ColorSelector",
            default: "#f8fafc",
            description: "Calendar week numbers background color",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.weeknumbers.fontSize",
            component: "FontSizeSelector",
            default: "0.75rem",
            allowCustom: true,
            description: "Calendar week numbers font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.weeknumbers.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Calendar week numbers font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.weeknumbers.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar week numbers font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Calendar - Day",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.day.color",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Calendar day text color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Day Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.calendar.day.background",
            component: "ColorSelector",
            default: "#3b82f6",
            description: "Calendar day background color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Day Background Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.day.fontSize",
            component: "FontSizeSelector",
            default: "1rem",
            allowCustom: true,
            description: "Calendar day font size",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Day Background Color",
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.day.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Calendar day font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.day.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar day font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Calendar - Current Day",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.calendar.currentDay.color",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Calendar current day text color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Current Day Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.calendar.currentDay.background",
            component: "ColorSelector",
            default: "#3b82f6",
            description: "Calendar current day background color",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Current Day Background Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.calendar.currentDay.fontSize",
            component: "FontSizeSelector",
            default: "1rem",
            allowCustom: true,
            description: "Calendar current day font size",
            options: {
              allowInherit: true,
              modalTitle: "Calendar Current Day Background Color",
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.calendar.currentDay.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Calendar current day font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.calendar.currentDay.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Calendar current day font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
    ],
  },
];
